import { useBackendApi } from './backendApi';
import { ValidationSchema } from 'validation-schema';
import { useEventsPublisher } from 'event-bus';
import { TEAM_SETUP_AREAS_UPDATED } from './teamSetupAreasService';
import { ProjectType } from './Types';
import { Plan } from './plansService';

export interface CreateCustomSetupAreaRequest {
  name: string,
  alias: string,
  projectType: ProjectType,
  timezone?: string,
}

export interface UpdateCustomSetupAreaRequest {
  name: string,
  alias: string,
  projectType: ProjectType,
  timezone?: string,
}

export interface CopyCustomProcessRequest {
  name: string,
  alias: string,
  projectType: ProjectType,
}

export interface CreatePlanFromCustomProcessRequest {
  name: string,
}

export function useCustomSetupAreasService() {

  const backendApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const createCustomSetupArea = async (request: CreateCustomSetupAreaRequest) => {
    const result = await backendApi.post('/customprocesses', request);

    eventsPublisher.publish(TEAM_SETUP_AREAS_UPDATED, {});

    return result;
  }

  const updateCustomSetupArea = async (id: number, request: UpdateCustomSetupAreaRequest) => {
    const result =  await backendApi.put(`/customprocesses/${id}`, request);

    eventsPublisher.publish(TEAM_SETUP_AREAS_UPDATED, {});

    return result;
  }

  const copyCustomSetupArea = async (id: number, request: CopyCustomProcessRequest) => {
    const result = await backendApi.post(`/customprocesses/${id}/copy`, request);

    eventsPublisher.publish(TEAM_SETUP_AREAS_UPDATED, {});

    return result;
  }

  const createPlanFromCustomProcess = async (id: number, request: CreatePlanFromCustomProcessRequest): Promise<Plan> => {
    return await backendApi.post(`/customprocesses/${id}/plan`, request);
  }

  const getValidationSchema = () => {
    return {
      name: {
        type: 'string',
        constraints: {
          required: true,
          minLength: 3,
          maxLength: 100,
        }
      },
      alias: {
        type: 'string',
        constraints: {
          required: true,
          minLength: 3,
          maxLength: 30,
        }
      },
      projectType: {
        type: 'string',
        constraints: {
          required: true,
        }
      }
    } as ValidationSchema;
  }

  return {
    createCustomSetupArea,
    updateCustomSetupArea,
    copyCustomSetupArea,
    createPlanFromCustomProcess,
    getValidationSchema,
  }
}
